import { render, staticRenderFns } from "./CreateGroupConversationModal.vue?vue&type=template&id=8a60bf40"
import script from "./CreateGroupConversationModal.vue?vue&type=script&lang=ts"
export * from "./CreateGroupConversationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a60bf40')) {
      api.createRecord('8a60bf40', component.options)
    } else {
      api.reload('8a60bf40', component.options)
    }
    module.hot.accept("./CreateGroupConversationModal.vue?vue&type=template&id=8a60bf40", function () {
      api.rerender('8a60bf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/CreateGroupConversationModal.vue"
export default component.exports